module.exports = __webpack_public_path__ + "img/star.9cc06adf.svg";